import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import Checkbox from '~/components/shared/CheckBox/CheckBox';
import { Body } from '@qred/components-library';
import { RootState } from '~/store';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';
import { onChangeInputEvent } from '~/types/types';
import { updateForm } from '~/store/slices/loanOffer.slice';
import useLoanConsentText from '~/hooks/useLoanConsentText';

const TermsAndConditions = () => {
  const dispatch = useAppDispatch();

  const {
    loanOffer: {
      form,
      overview: { loanType },
    },
  } = useSelector((state: RootState) => state);

  const consentText = useLoanConsentText({ loanType });

  const onChange = (event: onChangeInputEvent) => {
    const { checked } = event.target;
    dispatch(updateForm({ offerIsAgreed: checked }));
    dispatch(
      pushToGtmLoanAction({
        actionName: 'terms_agreement_change',
      })
    );
  };

  return (
    <>
      <Checkbox
        checked={form.offerIsAgreed}
        dataCy="terms_and_conditions_checkbox"
        name="offerIsAgreed"
        onChange={onChange}
        validationType="Required"
      >
        <Body size={'sm'}>{consentText}</Body>
      </Checkbox>
    </>
  );
};

export default TermsAndConditions;
